import classnames from 'classnames';
import { Color } from 'palette/Colors';
import { Icon } from 'palette/Icon';
import { Transition } from 'palette/Transition';
import { TVariant } from '../types';
import './ToggleIcon.scss';

interface IToggleIcon {
    variant: TVariant;
    hasError: boolean;
    isChecked: boolean;
    className?: string;
    isDisabled?: boolean;
}

function ToggleIcon({
    variant,
    hasError,
    className,
    isChecked,
    isDisabled,
}: IToggleIcon) {
    const showCheckboxIcon = variant === 'checkbox' && isChecked;

    const getIconColor = (): Color => {
        if (hasError) { return 'red-700'; }
        if (isDisabled) { return 'grey-300'; }
        return 'white';
    };

    return (
        <Transition
            property="background-color"
            timeout="quick"
        >
            <div className={classnames('palette-toggle-icon', className, {
                'palette-toggle-icon--checked': isChecked,
                'palette-toggle-icon--error': hasError,
                'palette-toggle-icon--disabled': isDisabled,
                [`palette-toggle-icon--${variant}`]: variant,
            })}
            >
                {
                    showCheckboxIcon && (
                        <Icon
                            color={getIconColor()}
                            name="palette_check"
                            size="x-small"
                        />
                    )
                }
            </div>
        </Transition>
    );
}

export default ToggleIcon;
